import {
  type OfferV1,
  type PimProductV1,
} from '@redteclab/api/clients/composition-service-product'

import { type CartIntermediateEntryObject } from '../../../cart-intermediate'
import { type PublicGlobalConfig } from '../../../global-config'
import { productIsOwnBrand } from '../../../product'
import { type UdpTrackingProductAddToCart } from '../../../udp-tracking'
import { offerAccessorIsOfferMirakl } from '../../model/offerAccessor/offerAccessorIsOfferMirakl'
import { priceAccessorGetDisplayPriceInCents } from '../../model/priceAccessor/priceAccessorGetDisplayPriceInCents'
import { productAccessorGetDiscountFromOffer } from '../../model/productAccessor/productAccessorGetDiscountFromOffer'
import { productAccessorGetDoesSupportNow } from '../../model/productAccessor/productAccessorGetDoesSupportNow'

export const productPageUdpTrackingBuildProductAddToCart = ({
  currentOffer,
  currentPrescriptionType,
  currentVariant,
  globalConfig,
  isSponsored,
  quantity,
}: {
  currentOffer: OfferV1
  currentPrescriptionType: CartIntermediateEntryObject['prescriptionType']
  currentVariant: PimProductV1
  globalConfig: PublicGlobalConfig
  isSponsored?: boolean
  quantity: number
}): UdpTrackingProductAddToCart | undefined => {
  const priceAmount = priceAccessorGetDisplayPriceInCents(
    currentOffer,
    currentPrescriptionType,
  )

  if (priceAmount === null || !currentVariant.stock_status) {
    return undefined
  }

  const strikePriceAmount = currentOffer.strikeThroughOfferPrice?.price

  return {
    is_marketplace: offerAccessorIsOfferMirakl(currentOffer.offerType),
    is_now_product: productAccessorGetDoesSupportNow(currentOffer),
    is_own_brand:
      currentVariant.brand !== undefined &&
      productIsOwnBrand(currentVariant.brand.name),
    is_sponsored: isSponsored,
    price: {
      amount: priceAmount,
      discount: productAccessorGetDiscountFromOffer({
        currentPrescriptionType,
        offer: currentOffer,
        tenant: globalConfig.tenant,
      }),
      ...(strikePriceAmount && {
        strike_price: Math.round(strikePriceAmount * 100),
      }),
    },
    quantity,
    rating: currentVariant.rating?.average ?? 0,
    ...(currentOffer.seller && {
      seller: {
        id: currentOffer.seller.sellerId,
      },
    }),
    status: currentVariant.stock_status,
    upid: currentVariant.upid,
  }
}
